<template>
    <span class="svg-container" v-html="svg"></span>
</template>
<script>
    export default {
        props: ['svg']
    }
</script>

<style lang="scss" scoped>
    .svg-container {
        display: block;
        width: 100%;
        height: 100%;
        text-align: center;
    }
</style>
